module.exports = "https://static.wmbcdn.com/uniweb/images/7612da0a96ba69fc0a20a50c5b69571c.jpg";